// Shared metadata for the statistics section (English keys; labels via t()).
export const CATEGORY_META = [
  { key: "spa", label: "Spa", color: "#577b87" },
  { key: "swimSpa", label: "Swim spa", color: "#1AD5AF" },
  { key: "sauna", label: "Sauna", color: "#FCB03E" },
  { key: "accessory", label: "Accessories", color: "#8fa9b8" },
  { key: "sparePart", label: "Spare part", color: "#cabaab" },
  { key: "marketing", label: "Marketing", color: "#b085c9" },
];

export const MONTH_KEYS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const formatEuro = (value) =>
  `${(Number(value) || 0).toLocaleString("fr-FR", {
    maximumFractionDigits: 0,
  })} €`;
